/* Pygmalion: chic filter panel for the tablescape and gift box builders.
   Replaces the two dropdowns with open word lists (collection) and colour
   dots (colour). The original selects stay in the page, hidden, and still
   drive the filtering in pygmalion-bundle-v2.js. */
(() => {
  const SWATCH = {
    'red-pink': '#C24E5A',
    green: '#5B6B3A',
    blue: '#3E5A86',
    yellow: '#D5CF58',
    orange: '#CA4E22',
    brown: '#6E4B2F',
    neutral: 'linear-gradient(135deg, #212622 0 50%, #F0EDE5 50% 100%)'
  };

  const CSS = `
    .pyg-bundle-page .pyg-filter-panel[data-pyg-chic]{background:#F0EDE5!important;border:1px solid rgba(56,27,33,.16)!important;box-shadow:none!important;padding:26px 26px 18px!important;width:min(360px,calc(100vw - 28px))!important;color:#381B21!important;text-align:left!important}
    .pyg-bundle-page .pyg-filter-panel[data-pyg-chic] label{display:block;font:400 10px/1.2 'Pygmalion Acumin',acumin-pro,Arial,sans-serif!important;letter-spacing:.18em!important;text-transform:uppercase!important;color:#381B21!important;opacity:.6;margin:0 0 10px!important}
    .pyg-bundle-page .pyg-filter-panel[data-pyg-chic] .pyg-filter-apply{display:none!important}
    .pyg-chic-native{position:absolute!important;width:1px!important;height:1px!important;margin:0!important;padding:0!important;border:0!important;opacity:0!important;pointer-events:none!important;clip:rect(0 0 0 0)!important;overflow:hidden!important}
    .pyg-chic-group{display:flex;flex-wrap:wrap;gap:2px 20px;margin:0 0 24px}
    .pyg-chic-group--colour{display:grid;grid-template-columns:repeat(2,max-content);gap:2px 36px}
    .pyg-bundle-page .pyg-chic-option{appearance:none;background:none!important;border:0!important;border-radius:0;box-shadow:none!important;margin:0;padding:4px 0;min-height:34px;display:inline-flex;align-items:center;gap:10px;cursor:pointer;color:#381B21!important;font:400 17px/1.25 'Pygmalion Kindersley',kindersley,Georgia,serif!important;letter-spacing:0!important;text-transform:none!important;text-align:left}
    .pyg-chic-text{opacity:.68;white-space:nowrap;transition:opacity .2s ease}
    .pyg-chic-option:hover .pyg-chic-text,.pyg-chic-option[aria-checked="true"] .pyg-chic-text{opacity:1}
    .pyg-chic-option[aria-checked="true"] .pyg-chic-text{text-decoration:underline;text-decoration-thickness:1px;text-underline-offset:5px}
    .pyg-bundle-page .pyg-chic-option:focus-visible{outline:1px solid currentColor!important;outline-offset:3px!important}
    .pyg-chic-dot{width:11px;height:11px;border-radius:50%;flex:none;box-shadow:inset 0 0 0 1px rgba(56,27,33,.2)}
    .pyg-chic-foot{display:flex;justify-content:space-between;align-items:center;gap:12px;padding-top:14px;border-top:1px solid rgba(56,27,33,.16);font:400 10px/1.2 'Pygmalion Acumin',acumin-pro,Arial,sans-serif;letter-spacing:.16em;text-transform:uppercase;color:#381B21}
    .pyg-chic-count{opacity:.6}
    .pyg-bundle-page .pyg-chic-clear{appearance:none;background:none!important;border:0!important;padding:0;min-height:28px;cursor:pointer;color:#381B21!important;font:inherit!important;letter-spacing:inherit!important;text-transform:inherit!important;text-decoration:underline;text-underline-offset:3px}
    .pyg-chic-clear[hidden]{display:none!important}
    .pyg-filter-trigger .pyg-chic-active{display:inline-block;width:5px;height:5px;border-radius:50%;background:currentColor;margin-left:-4px}
    .pyg-filter-trigger .pyg-chic-active[hidden]{display:none}
    @media (pointer:coarse){.pyg-bundle-page .pyg-chic-option{min-height:42px}}
    @media (prefers-reduced-motion:reduce){.pyg-chic-text{transition:none}}
  `;

  function injectCss() {
    if (document.getElementById('pyg-chic-filter-css')) return;
    const style = document.createElement('style');
    style.id = 'pyg-chic-filter-css';
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  const visibleCount = () =>
    document.querySelectorAll('.bndlr-mnm-available-products > .bndlr-product:not([hidden])').length;

  function change(select, value) {
    if (select.value === value) return;
    select.value = value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function enhance(panel) {
    if (panel.dataset.pygChic) return;
    const selects = [...panel.querySelectorAll('select')];
    if (!selects.length) return;
    panel.dataset.pygChic = '1';
    injectCss();

    selects.forEach(select => {
      const label = panel.querySelector(`label[for="${select.id}"]`);
      const isColour = /colou?r/i.test(select.id);
      const group = document.createElement('div');
      group.className = 'pyg-chic-group' + (isColour ? ' pyg-chic-group--colour' : '');
      group.setAttribute('role', 'radiogroup');
      if (label) {
        label.id = label.id || select.id + '-label';
        label.removeAttribute('for');
        group.setAttribute('aria-labelledby', label.id);
      }
      [...select.options].forEach(option => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'pyg-chic-option';
        button.dataset.value = option.value;
        button.setAttribute('role', 'radio');
        if (isColour && option.value !== 'all') {
          const dot = document.createElement('span');
          dot.className = 'pyg-chic-dot';
          dot.setAttribute('aria-hidden', 'true');
          dot.style.background = SWATCH[option.value] || '#D9D3C4';
          button.append(dot);
        }
        const text = document.createElement('span');
        text.className = 'pyg-chic-text';
        text.textContent = option.value === 'all' ? 'All' : option.textContent.trim();
        button.append(text);
        button.addEventListener('click', () => { change(select, option.value); sync(); });
        group.append(button);
      });
      group.addEventListener('keydown', event => {
        const forward = event.key === 'ArrowRight' || event.key === 'ArrowDown';
        const back = event.key === 'ArrowLeft' || event.key === 'ArrowUp';
        if (!forward && !back) return;
        const items = [...group.querySelectorAll('.pyg-chic-option')];
        let index = items.indexOf(document.activeElement);
        if (index < 0) return;
        event.preventDefault();
        index = (index + (forward ? 1 : -1) + items.length) % items.length;
        items[index].focus();
        items[index].click();
      });
      select.classList.add('pyg-chic-native');
      select.tabIndex = -1;
      select.setAttribute('aria-hidden', 'true');
      select.after(group);
    });

    const foot = document.createElement('div');
    foot.className = 'pyg-chic-foot';
    foot.innerHTML = '<span class="pyg-chic-count" role="status" aria-live="polite"></span><button type="button" class="pyg-chic-clear" hidden>Clear</button>';
    foot.querySelector('.pyg-chic-clear').addEventListener('click', () => {
      selects.forEach(select => change(select, 'all'));
      sync();
    });
    panel.append(foot);

    const trigger = panel.closest('details')?.querySelector('.pyg-filter-trigger');
    if (trigger && !trigger.querySelector('.pyg-chic-active')) {
      const mark = document.createElement('span');
      mark.className = 'pyg-chic-active';
      mark.setAttribute('aria-hidden', 'true');
      mark.hidden = true;
      trigger.append(mark);
    }
  }

  function sync() {
    document.querySelectorAll('.pyg-filter-panel[data-pyg-chic]').forEach(panel => {
      const selects = [...panel.querySelectorAll('select')];
      selects.forEach(select => {
        const group = select.nextElementSibling;
        if (!group || !group.classList.contains('pyg-chic-group')) return;
        group.querySelectorAll('.pyg-chic-option').forEach(button => {
          const on = String(button.dataset.value === select.value);
          if (button.getAttribute('aria-checked') !== on) button.setAttribute('aria-checked', on);
          const tab = on === 'true' ? 0 : -1;
          if (button.tabIndex !== tab) button.tabIndex = tab;
        });
      });
      const count = visibleCount();
      const text = count === 1 ? 'Showing 1 candle' : `Showing ${count} candles`;
      const counter = panel.querySelector('.pyg-chic-count');
      if (counter && counter.textContent !== text) counter.textContent = text;
      const filtered = selects.some(select => select.value !== 'all');
      const clear = panel.querySelector('.pyg-chic-clear');
      if (clear && clear.hidden === filtered) clear.hidden = !filtered;
      const mark = panel.closest('details')?.querySelector('.pyg-chic-active');
      if (mark && mark.hidden === filtered) mark.hidden = !filtered;
    });
  }

  let queued = false;
  function run() {
    queued = false;
    document.querySelectorAll('.pyg-filter-panel').forEach(enhance);
    sync();
  }
  function queue() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(run);
  }

  document.addEventListener('DOMContentLoaded', queue);
  new MutationObserver(queue).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['hidden']
  });
  queue();
})();
